const PUBLIC_EVENTS_CACHE_KEY = "echo_jham_public_events_cache_v1";

export const writePublicEventsCache = (events) => {
  try {
    if (!Array.isArray(events) || events.length === 0) return;

    const payload = {
      updatedAt: new Date().toISOString(),
      events,
    };

    localStorage.setItem(PUBLIC_EVENTS_CACHE_KEY, JSON.stringify(payload));
  } catch {
    // Ignore cache write failures.
  }
};

export const readPublicEventsCache = () => {
  try {
    const raw = localStorage.getItem(PUBLIC_EVENTS_CACHE_KEY);
    if (!raw) return [];

    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed?.events)) return [];

    return parsed.events;
  } catch {
    return [];
  }
};
